import { render } from "./ListItemLivro.vue?vue&type=template&id=6120d963&scoped=true"
import script from "./ListItemLivro.vue?vue&type=script&lang=js"
export * from "./ListItemLivro.vue?vue&type=script&lang=js"

import "./ListItemLivro.vue?vue&type=style&index=0&id=6120d963&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6120d963"]])

export default __exports__